import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectBusiness,
  selectProfileData,
} from '@pages/profile/store/selectors';
import { Currencies, Countries } from '@constants/enums';
import { COUNTRY_TO_CURRENCY_MAP } from '../constants';

const useDefaultCurrency = (): Currencies => {
  const business = useSelector(selectBusiness);
  const userProfile = useSelector(selectProfileData);

  const defaultCurrency = useMemo(() => {
    if (business?.accountCurrency) {
      return business.accountCurrency as Currencies;
    }

    if (userProfile?.company?.country) {
      const countryCode = userProfile.company.country as Countries;
      const mappedCurrency = COUNTRY_TO_CURRENCY_MAP[countryCode];

      if (mappedCurrency) {
        return mappedCurrency;
      }
    }

    if (business?.country) {
      const countryCode = business.country as Countries;
      const mappedCurrency = COUNTRY_TO_CURRENCY_MAP[countryCode];

      if (mappedCurrency) {
        return mappedCurrency;
      }
    }

    return Currencies.USD;
  }, [business, userProfile]);

  return defaultCurrency;
};

export default useDefaultCurrency;
